import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, MailchimpIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Mailchimp } from 'blaze-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { MailchimpInitialization } from 'components/IntegrationInitialization'
import { MailchimpSettingsModal } from '../MailchimpSettingsModal/MailchimpSettingsModal'

export const MailchimpCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: MailchimpIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  const isConnected = integrations.length > 0
  const showSettings = isConnected && !isDisconnected
  const integration = integrations[0]

  return (
    <ExternalIntegrationCard
      title={'Mailchimp'}
      description={'Connect your email marketing campaigns with Mailchimp integration'}
      integrations={integrations}
      icon={<Mailchimp size={20} />}
      onSettingsPress={showSettings ? () => openModal(MailchimpSettingsModal, { integration }) : undefined}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(MailchimpInitialization)}
          provider={ExternalIntegrationEnum.Mailchimp}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
